import { ApiContactDto } from '@/shared/api';
import { generateDtoId } from '@/shared/lib/sj-orm/helpers';
import { ContactDto, isContactType } from '@/shared/lib/sj-orm/models/contacts';
import { CollectionName } from '@/shared/lib/sj-orm/types';
import { AIStatus } from '@/shared/types';

import { getValidContact } from '../validator';

export const makeContacts = (
  aiProps: {
    aiStatus: AIStatus;
  },
  contactsDtos: ApiContactDto[],
) => {
  const newContacts = contactsDtos.map<ContactDto | null>((contact) => {
    if (!isContactType(contact.type)) return null;
    const data = getValidContact({ data: contact, type: contact.type });
    if (!data) return null;

    return {
      id: generateDtoId(CollectionName.CONTACTS),
      ...data,
      type: contact.type,
      ...aiProps,
    };
  });

  return newContacts.filter((newContact) => newContact !== null);
};
